export default "__VITE_ASSET__BCUrGk8U__"